module.exports = __webpack_public_path__ + "static/profile-6a6d003d7e8a05f703dbee8710e0d312.png";